export const teammateInviteInternalErrorMessage = `An unexpected error occurred. Please try submitting an email address again. Need help? Contact support.`;
export const teammateInviteInvalidTokenErrorMessage = `Your invitation token is invalid or has expired. Please return to the Marketplace and start the Single Sign On process over again. Need help? Contact support.`;
export const teammateInviteUsernameNotAvailableErrorMessage = `The email provided is already linked to a SendGrid account. Please try a different email address. Need help? Contact support.`;
export const userForbiddenAccessErrorMessage = `You are not authorized to access this account. Please contact your administrator or support for help.`;

// it's assumed that email will be a defined string when passed in here; getErrorMessageByCode
// does this check for us.
export const teammateInviteMustLinkBeforeAcceptingErrorMessage = (email?: string) => (
  <p style={{ margin: "0 10px" }}>
    {email ? (
      <>
        To use this email address, you must first log in to SendGrid with the username{" "}
        <strong>{email}</strong> and set up Twilio login. Please see{" "}
      </>
    ) : (
      <>
        To use this email address, you must first log in to SendGrid with the username provided and
        set up Twilio login. Please see{" "}
      </>
    )}
    <a
      target="_blank"
      rel="noreferrer"
      href="https://www.twilio.com/docs/sendgrid/ui/account-and-settings/twilio-login-overview#migrate-your-sendgrid-account-to-twilio-login">
      Twilio login overview
    </a>{" "}
    for more details.
  </p>
);

export const ipAddressNotAllowedErrorMessage = (
  <p style={{ margin: "0 10px" }}>
    Your IP address is not allowed. See{" "}
    <a
      target="_blank"
      rel="noreferrer"
      href="https://www.twilio.com/docs/sendgrid/ui/account-and-settings/ip-access-management">
      https://www.twilio.com/docs/sendgrid/ui/account-and-settings/ip-access-management
    </a>{" "}
    for more details.
  </p>
);

/**
 * Maps error codes to user-facing display messages for the unified_login identifier page.
 *
 * Covers codes from two sources:
 * - Chaos POST /v1/teammates/:token/verify-email (teammate invite flow)
 * - /v3/sessions sign-in errors rerouted back here by tryRedirectingUser (CLRF-2268)
 */
export const getErrorMessageByCode = (
  errorCode: string,
  email?: string
): string | JSX.Element | undefined => {
  const errorMessages: Record<string, string | JSX.Element> = {
    "": teammateInviteInternalErrorMessage,
    ERR_TEAMMATE_INVITE_INTERNAL: teammateInviteInternalErrorMessage,
    ERR_TEAMMATE_INVITE_INVALID_TOKEN: teammateInviteInvalidTokenErrorMessage,
    ERR_TEAMMATE_INVITE_USERNAME_NOT_AVAILABLE: teammateInviteUsernameNotAvailableErrorMessage,
    ERR_TEAMMATE_INVITE_MUST_LINK_BEFORE_ACCEPTING: email
      ? teammateInviteMustLinkBeforeAcceptingErrorMessage(email)
      : teammateInviteInternalErrorMessage,
    ERR_IP_ADDRESS_NOT_ALLOWED: ipAddressNotAllowedErrorMessage,
    ERR_USER_FORBIDDEN_ACCESS: userForbiddenAccessErrorMessage,
  };

  return errorMessages[errorCode];
};
